import React from 'react';
import PropTypes from 'prop-types';
import Styles from './summarytable.module.scss';
import dollarize, { calculateEasePrice } from '../utils/displayHelpers';
import IpSelector from './IpSelector';
import EaseSelector from './EaseSelector';
import withAddOns from '../containers/withAddOns';
import { ADDONS } from '../constants';


const AddonRow = (props) => {
  let fullPrice;
  switch (props.type) {
    case ADDONS.DEDICATED_IP:
      fullPrice = ADDONS.IP_COST * props.addOns[ADDONS.DEDICATED_IP];
      break;
    case ADDONS.EASE:
      fullPrice = calculateEasePrice(props.addOns[ADDONS.EASE], props.package);
      break;
    default:
      break;
  }

  return (
    <tr className={`${props.type}-row`} >
      <th className={`service-${props.type}`}>
        {props.type === ADDONS.EASE ? <EaseSelector package={props.package} /> : ''}
        {props.type === ADDONS.DEDICATED_IP ? <IpSelector /> : ''}
      </th>
      <td className={Styles.price}>
        {dollarize(fullPrice)}
      </td>
    </tr>
  );
};

AddonRow.propTypes = {
  addOns: PropTypes.shape({
    [ADDONS.DEDICATED_IP]: PropTypes.number.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  package: PropTypes.string,
};

AddonRow.defaultProps = {
  package: '',
};

export default withAddOns(AddonRow);



// WEBPACK FOOTER //
// ./src/components/AddonRow.jsx